import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { TransitionMotion, spring, presets } from 'react-motion'
import styles from './wizard-progress.styl'

export default class WizardProgress extends Component {
  static propTypes = {
    links: PropTypes.any,
    route: PropTypes.object
  }

  willEnter = () => ({ size: 0.6, opacity: 0 })

  willLeave = () => ({
    size: spring(0, presets.stiff),
    opacity: spring(0, presets.stiff)
  })

  render() {
    const { links } = this.props

    const activeArr = links
      .filter(item => {
        return item.active === true
      })
      .map(item => ({
        key: `${item.id}`,
        data: item,
        style: {
          size: spring(1, presets.stiff),
          opacity: spring(1, presets.stiff)
        }
      }))

    return (
      <TransitionMotion
        willEnter={this.willEnter}
        willLeave={this.willLeave}
        styles={activeArr.toArray()}
      >
        {interpolatedStyles => (
          <ul className={styles.wrap}>
            {interpolatedStyles.map((obj, index) => {
              const isActive = this.props.route.activeId === obj.data.id
              const activeClass = isActive ? styles.active : ''
              const isDone = obj.data.completed

              return (
                <li
                  key={obj.key}
                  style={{
                    transform: `scale3d(${obj.style.size}, ${obj.style.size}, ${obj.style.size})`,
                    opacity: obj.style.opacity
                  }}
                  className={`${styles.item} ${activeClass}`}
                >
                  <span className={styles.step}>
                    {isDone
                      ? <span className={styles.indexChecked}>
                        <i className="ico ico--checked" />
                      </span>
                      : <span className={styles.index}>{index + 1}</span>}
                    <span className={styles.label}>
                      {obj.data.intlKey
                        ? <FormattedMessage
                            id={obj.data.intlKey}
                            defaultMessage={obj.data.label}
                        />
                        : obj.data.label}
                    </span>
                  </span>
                </li>
              )
            })}
          </ul>
        )}
      </TransitionMotion>
    )
  }
}
